/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { Pageable } from '../model/pageable';
// @ts-ignore
import { PagedModelTipoPraticaIstitutoPlessoDTO } from '../model/paged-model-tipo-pratica-istituto-plesso-dto';
// @ts-ignore
import { TipoPraticaIstitutoPlessoCreationForm } from '../model/tipo-pratica-istituto-plesso-creation-form';
// @ts-ignore
import { TipoPraticaIstitutoPlessoDTO } from '../model/tipo-pratica-istituto-plesso-dto';
// @ts-ignore
import { TipoPraticaIstitutoPlessoListFilter } from '../model/tipo-pratica-istituto-plesso-list-filter';
// @ts-ignore
import { TipoPraticaIstitutoPlessoPatchForm } from '../model/tipo-pratica-istituto-plesso-patch-form';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    TipoPraticaIstitutoPlessoControllerServiceInterface,
    CreateTipoPraticaIstitutoPlessoRequestParams,
    DeleteTipoPraticaIstitutoPlessoRequestParams,
    GetTipoPraticaIstitutoPlessoRequestParams,
    ListTipoPraticaIstitutoPlessiRequestParams,
    UpdateTipoPraticaIstitutoPlessoRequestParams
} from './tipo-pratica-istituto-plesso-controller.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class TipoPraticaIstitutoPlessoControllerService extends BaseService implements TipoPraticaIstitutoPlessoControllerServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Crea un nuovo Plesso sotto un Istituto
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}/plessi
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public createTipoPraticaIstitutoPlesso(requestParameters: CreateTipoPraticaIstitutoPlessoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TipoPraticaIstitutoPlessoDTO>;
    public createTipoPraticaIstitutoPlesso(requestParameters: CreateTipoPraticaIstitutoPlessoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TipoPraticaIstitutoPlessoDTO>>;
    public createTipoPraticaIstitutoPlesso(requestParameters: CreateTipoPraticaIstitutoPlessoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TipoPraticaIstitutoPlessoDTO>>;
    public createTipoPraticaIstitutoPlesso(requestParameters: CreateTipoPraticaIstitutoPlessoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling createTipoPraticaIstitutoPlesso.');
        }
        const idIstituto = requestParameters?.idIstituto;
        if (idIstituto === null || idIstituto === undefined) {
            throw new Error('Required parameter idIstituto was null or undefined when calling createTipoPraticaIstitutoPlesso.');
        }
        const tipoPraticaIstitutoPlessoCreationForm = requestParameters?.tipoPraticaIstitutoPlessoCreationForm;
        if (tipoPraticaIstitutoPlessoCreationForm === null || tipoPraticaIstitutoPlessoCreationForm === undefined) {
            throw new Error('Required parameter tipoPraticaIstitutoPlessoCreationForm was null or undefined when calling createTipoPraticaIstitutoPlesso.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/istituti/${this.configuration.encodeParam({name: "idIstituto", value: idIstituto, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/plessi`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TipoPraticaIstitutoPlessoDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: tipoPraticaIstitutoPlessoCreationForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Elimina un Plesso (cascade su Assegnazioni)
     * @endpoint delete /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}/plessi/{idPlesso}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public deleteTipoPraticaIstitutoPlesso(requestParameters: DeleteTipoPraticaIstitutoPlessoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteTipoPraticaIstitutoPlesso(requestParameters: DeleteTipoPraticaIstitutoPlessoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteTipoPraticaIstitutoPlesso(requestParameters: DeleteTipoPraticaIstitutoPlessoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteTipoPraticaIstitutoPlesso(requestParameters: DeleteTipoPraticaIstitutoPlessoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling deleteTipoPraticaIstitutoPlesso.');
        }
        const idIstituto = requestParameters?.idIstituto;
        if (idIstituto === null || idIstituto === undefined) {
            throw new Error('Required parameter idIstituto was null or undefined when calling deleteTipoPraticaIstitutoPlesso.');
        }
        const idPlesso = requestParameters?.idPlesso;
        if (idPlesso === null || idPlesso === undefined) {
            throw new Error('Required parameter idPlesso was null or undefined when calling deleteTipoPraticaIstitutoPlesso.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/istituti/${this.configuration.encodeParam({name: "idIstituto", value: idIstituto, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/plessi/${this.configuration.encodeParam({name: "idPlesso", value: idPlesso, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Dettaglio di un Plesso per id
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}/plessi/{idPlesso}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getTipoPraticaIstitutoPlesso(requestParameters: GetTipoPraticaIstitutoPlessoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TipoPraticaIstitutoPlessoDTO>;
    public getTipoPraticaIstitutoPlesso(requestParameters: GetTipoPraticaIstitutoPlessoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TipoPraticaIstitutoPlessoDTO>>;
    public getTipoPraticaIstitutoPlesso(requestParameters: GetTipoPraticaIstitutoPlessoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TipoPraticaIstitutoPlessoDTO>>;
    public getTipoPraticaIstitutoPlesso(requestParameters: GetTipoPraticaIstitutoPlessoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling getTipoPraticaIstitutoPlesso.');
        }
        const idIstituto = requestParameters?.idIstituto;
        if (idIstituto === null || idIstituto === undefined) {
            throw new Error('Required parameter idIstituto was null or undefined when calling getTipoPraticaIstitutoPlesso.');
        }
        const idPlesso = requestParameters?.idPlesso;
        if (idPlesso === null || idPlesso === undefined) {
            throw new Error('Required parameter idPlesso was null or undefined when calling getTipoPraticaIstitutoPlesso.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/istituti/${this.configuration.encodeParam({name: "idIstituto", value: idIstituto, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/plessi/${this.configuration.encodeParam({name: "idPlesso", value: idPlesso, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TipoPraticaIstitutoPlessoDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista paginata dei Plessi di un Istituto (filtri: nome, ordinamento, codice_meccanografico, attivo, q)
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}/plessi
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listTipoPraticaIstitutoPlessi(requestParameters: ListTipoPraticaIstitutoPlessiRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelTipoPraticaIstitutoPlessoDTO>;
    public listTipoPraticaIstitutoPlessi(requestParameters: ListTipoPraticaIstitutoPlessiRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelTipoPraticaIstitutoPlessoDTO>>;
    public listTipoPraticaIstitutoPlessi(requestParameters: ListTipoPraticaIstitutoPlessiRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelTipoPraticaIstitutoPlessoDTO>>;
    public listTipoPraticaIstitutoPlessi(requestParameters: ListTipoPraticaIstitutoPlessiRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling listTipoPraticaIstitutoPlessi.');
        }
        const idIstituto = requestParameters?.idIstituto;
        if (idIstituto === null || idIstituto === undefined) {
            throw new Error('Required parameter idIstituto was null or undefined when calling listTipoPraticaIstitutoPlessi.');
        }
        const filter = requestParameters?.filter;
        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling listTipoPraticaIstitutoPlessi.');
        }
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling listTipoPraticaIstitutoPlessi.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'filter',
            <any>filter,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/istituti/${this.configuration.encodeParam({name: "idIstituto", value: idIstituto, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/plessi`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelTipoPraticaIstitutoPlessoDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Replace di un Plesso (richiede version per optimistic lock)
     * @endpoint put /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}/plessi/{idPlesso}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public updateTipoPraticaIstitutoPlesso(requestParameters: UpdateTipoPraticaIstitutoPlessoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TipoPraticaIstitutoPlessoDTO>;
    public updateTipoPraticaIstitutoPlesso(requestParameters: UpdateTipoPraticaIstitutoPlessoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TipoPraticaIstitutoPlessoDTO>>;
    public updateTipoPraticaIstitutoPlesso(requestParameters: UpdateTipoPraticaIstitutoPlessoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TipoPraticaIstitutoPlessoDTO>>;
    public updateTipoPraticaIstitutoPlesso(requestParameters: UpdateTipoPraticaIstitutoPlessoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling updateTipoPraticaIstitutoPlesso.');
        }
        const idIstituto = requestParameters?.idIstituto;
        if (idIstituto === null || idIstituto === undefined) {
            throw new Error('Required parameter idIstituto was null or undefined when calling updateTipoPraticaIstitutoPlesso.');
        }
        const idPlesso = requestParameters?.idPlesso;
        if (idPlesso === null || idPlesso === undefined) {
            throw new Error('Required parameter idPlesso was null or undefined when calling updateTipoPraticaIstitutoPlesso.');
        }
        const tipoPraticaIstitutoPlessoPatchForm = requestParameters?.tipoPraticaIstitutoPlessoPatchForm;
        if (tipoPraticaIstitutoPlessoPatchForm === null || tipoPraticaIstitutoPlessoPatchForm === undefined) {
            throw new Error('Required parameter tipoPraticaIstitutoPlessoPatchForm was null or undefined when calling updateTipoPraticaIstitutoPlesso.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/istituti/${this.configuration.encodeParam({name: "idIstituto", value: idIstituto, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/plessi/${this.configuration.encodeParam({name: "idPlesso", value: idPlesso, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TipoPraticaIstitutoPlessoDTO>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: tipoPraticaIstitutoPlessoPatchForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
